export default __webpack_public_path__ + "static/media/14.65b9e4e3.webp";